<template>
  <portal selector="#fullscreen-portal-target">
    <div id="image-viewer" class="pos-fixed pos-top-center">
      <div class="pos-absolute pos-top-right mx-2 mt-2 z-1 d-flex flex-justify-end" style="gap: 8px">
        <template v-if="!isNative">
          <div class="c-pointer" :class="[zoomExponent < 1 ? 'fg-white' : 'fg-gray disabled']" key="moreZoom"
               @click="changeZoom(0.2)">
            <i class="fa-solid fa-magnifying-glass-plus fa-xl"></i>
          </div>
          <div class="c-pointer" :class="[zoomExponent > 0 ? 'fg-white' : 'fg-gray disabled']" key="lessZoom"
               @click="changeZoom(-0.2)">
            <i class="fa-solid fa-magnifying-glass-minus fa-xl"></i>
          </div>
        </template>
        <div class="c-pointer fg-white" @click="close()" key="close">
          <i class="fa-solid fa-circle-xmark fa-xl"></i>
        </div>
      </div>
      <div class="h-100 w-100 p-2 d-flex flex-align-center flex-justify-center" style="overflow: auto;"
           ref="imageContainer">
        <img :src="url" alt="" :style="imageStyle" ref="image">
      </div>
    </div>
  </portal>
</template>

<script>
import { Portal } from '@linusborg/vue-simple-portal'
import { Capacitor } from '@capacitor/core';

export default {
  name: "image-viewer",
  data() {
    return {
      isNative: Capacitor.isNativePlatform(),
      zoomExponent: 0,
      initialDims: null
    }
  },
  props: {
    url: {
      type: String,
      required: true
    }
  },
  components: {
    Portal
  },
  destroyed() {
    this.$store.commit('SET_FULLSCREEN_COMPONENT', false)
    $(".app-block").css("overflow", "scroll")
  },
  mounted() {
    this.$store.commit('SET_FULLSCREEN_COMPONENT', true)
    $(".app-block").css("overflow", "hidden")

    if (!this.isNative) {
      setTimeout(() => {
        if (this.$refs.image.complete) {
          this.setInitialDims()
        } else {
          this.$refs.image.addEventListener('load', this.setInitialDims, {once: true})
        }
      }, 100)
    }
  },
  computed: {
    fullscreenComponent() {
      return this.$store.getters.fullscreenComponent
    },
    imageStyle() {
      return {
        'transform': `scale(${this.zoomFactor}) translate(${this.translateX}px, ${this.translateY}px)`,
      }
    },
    zoomFactor() {
      return Math.pow(2, this.zoomExponent)
    },
    translateX() {
      if (this.initialDims) {
        return Math.max(
            0,
            (this.initialDims.imageWidth * this.zoomFactor - this.initialDims.containerWidth) / (2 * this.zoomFactor)
        )
      } else {
        return 0
      }
    },
    translateY() {
      if (this.initialDims) {
        return Math.max(
            0,
            (this.initialDims.imageHeight * this.zoomFactor - this.initialDims.containerHeight) / (2 * this.zoomFactor)
        )
      } else {
        return 0
      }
    }
  },
  methods: {
    close() {
      this.$emit('close-image-viewer')
    },
    setInitialDims() {
      this.initialDims = {
        containerWidth: this.$refs.imageContainer.scrollWidth,
        containerHeight: this.$refs.imageContainer.scrollHeight,
        imageWidth: this.$refs.image.width,
        imageHeight: this.$refs.image.height,
      }
    },
    changeZoom(zoom) {
      if (zoom > 0) {
        this.zoomExponent = Math.min(1, this.zoomExponent + zoom)
      } else {
        this.zoomExponent = Math.max(0, this.zoomExponent + zoom)
      }
    }
  },
  watch: {
    fullscreenComponent(newVal) {
      if (!newVal) {
        this.close()
      }
    }
  }
}
</script>

<style scoped>
#image-viewer {
  background-color: rgba(33,31,31,0.95);
  height: calc(var(--vh) * 100 - var(--safe-area-inset-top) - var(--safe-area-inset-bottom));
  width: 100%;
  margin-top: var(--safe-area-inset-top);
  margin-bottom: var(--safe-area-inset-bottom);
}
img {
  object-fit: scale-down;
  transform-origin: center;
  transition: transform 0.3s ease;
  max-height: 100%;
  max-width: 100%;
}
</style>